const metaAuth = {
  auth: 1,
  keepAlive: false,
};

export default [
  {
    path: "/360",
    name: "360",
    meta: metaAuth,
    component: () => import("@/views/basePcThree/index.vue"),
  },
  {
    path: "/biying",
    name: "biying",
    meta: metaAuth,
    component: () => import("@/views/basePcThree/index.vue"),
  },
  {
    path: "/sougou",
    name: "sougou",
    meta: metaAuth,
    component: () => import("@/views/basePcThree/index.vue"),
  },
  {
    path: "/nami",
    name: "nami",
    meta: metaAuth,
    component: () => import("@/views/basePcThree/index.vue"),
  },
  {
    path: "/biyingjjs",
    name: "biyingjjs",
    meta: metaAuth,
    component: () => import("@/views/basePcThree/index.vue"),
  },
];
